import { motion, useInView, useMotionValue, animate } from "framer-motion";
import { useEffect, useRef } from "react";
import { STATS } from "../../lib/content";

function Counter({ to, suffix = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const mv = useMotionValue(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(mv, to, {
      duration: 1.6,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => {
        if (ref.current) ref.current.textContent = `${Math.floor(v)}${suffix}`;
      },
    });
    return controls.stop;
  }, [inView, to, suffix, mv]);

  return <span ref={ref}>0{suffix}</span>;
}

export default function Stats() {
  return (
    <section className="relative py-24 md:py-32 border-y border-white/5" data-testid="stats-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-2">
          {STATS.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className="p-6 md:p-10 border-l border-white/10 first:border-l-0"
              data-testid={`stat-${i}`}
            >
              <div className="font-display text-white text-5xl md:text-7xl leading-none tracking-tighter">
                <Counter to={s.value} suffix={s.suffix} />
              </div>
              <div className="mt-5 text-white/72 text-sm md:text-base max-w-[200px] leading-snug">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
